import { useEffect } from "react";

import {
  setDisplayMode,
  useAppDispatch,
  DisplayMode,
  login,
  setSession,
} from "./store";
import config from "./appconf";
import { connectToSSE } from "./EventSource";
import { SessionInfo } from "./common/Info";

function SplashPage() {
  const dispatch = useAppDispatch();
  useEffect(() => {
    fetch(`${config.baseUrl}/api/v1/accounts`, {
      mode: "cors",
      credentials: "include",
    })
      .then((res) => {
        if (res.status != 200) {
          dispatch(setDisplayMode(DisplayMode.login));
        } else {
          res.json().then((data) => {
            dispatch(login(data));
          });
          fetch(`${config.baseUrl}/api/v1/status`, {
            mode: "cors",
            credentials: "include",
          }).then((res) => {
            res.json().then((sessionInfo: SessionInfo) => {
              dispatch(setSession(sessionInfo));
            });
          });

          connectToSSE();
        }
      })
      .catch(() => {
        dispatch(setDisplayMode(DisplayMode.login));
      });
  }, []);

  return <div className="centerContainer height100"></div>;
}

export default SplashPage;
